import { AfterViewInit, Component, Input, QueryList, ViewChildren, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { NamedTemplateDirective } from 'src/app/directives/named-template.directive';
import { KeyValueMap } from 'src/app/models/key-value-map';
import { DynamicFormModel } from 'src/app/models/service/dynamic-form-model';
import { InstallationSchemaPropertyType } from 'src/app/models/service/installation-schema-property-type';


@Component({
    selector: 'app-dynamic-form',
    templateUrl: './dynamic-form.component.html',
    styleUrls: ['./dynamic-form.component.scss'],
    standalone: false
})
export class DynamicFormComponent implements AfterViewInit, AfterContentChecked {
  @Input() dynamicFormModel: DynamicFormModel;
  @Input() showTopLevelTitle = true;

  @ViewChildren(NamedTemplateDirective) templates: QueryList<NamedTemplateDirective>;
  templatesMap: KeyValueMap<string, NamedTemplateDirective>;

  InstallationSchemaPropertyType = InstallationSchemaPropertyType;

  constructor(private changeDetector: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.templatesMap = this.templates.reduce((accumulator, currentValue) => {
        accumulator[currentValue.appNamedTemplate] = currentValue.template;
        return accumulator;
      }, {});
    });
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  setProperties(control, defaultDesc, field?, property?): any {
    if (field === 'boolean') {
      control.value = control.value === 'true' || control.value === true ? true : false;
    }

    if(!control.value && !control.dirty && defaultDesc) {
      control.setValue(defaultDesc);
    }
    return control;
  }

  addTag($event: MatChipInputEvent, control: FormControl): void {
    $event.value.split(',').forEach(tag => {
      const trimmedTag = tag.trim();
      if (trimmedTag !== '' && !this.isDuplicateTag(trimmedTag, control)) {
        control.value.push(tag);
      }
    });
    control.updateValueAndValidity();
    $event.chipInput.inputElement.value = '';
  }

  selectTag($event: MatAutocompleteSelectedEvent, control: FormControl): void {
    if (!this.isDuplicateTag($event.option.value, control)) {
      control.value.push($event.option.value);
      control.updateValueAndValidity();
    }
  }

  removeTag(index: number, control: FormControl): void {
    control.value.splice(index, 1);
    control.updateValueAndValidity();
  }

  selectedValues(tag, property): any {
    return property?.updatedValue?.find(find=> find === tag);
  }

  setMultiSelectProperties(control, defaultVal): any {
    if(control.value.length === 0 && !control.dirty && defaultVal) {
      control.setValue([defaultVal]);
    }
    return control;
  }

  disableMultiselectField(property): any {
    if (property?.updatedValue) {
      return property?.updatedValue?.length === property?.items?.enum?.length;
    }
  }

  private isDuplicateTag(tag: string, control: FormControl): boolean {
    return control.value.find(value => value.toLowerCase() === tag.toLowerCase());
  }
}
